export const MAX_LOGO_FILE_SIZE_BYTES = 250 * 1024;
